import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { FilterGroupContainer, FilterItems } from "../components-atoms";
import {
  GeneralModal,
  HeaderWithButtons,
  InfoBox,
  InfoLine,
} from "../components-molecules";
import { HttpRegularDelete, HttpRegularPost, HttpRegularPut } from "../service";
import axios, { AxiosResponse } from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { getCategoriesSymbols } from "../redux/actions/getCategories";
import { getCollectionDetailsSymbols } from "../redux/actions/getCollectionDetails";
import { getCollectionsSymbols } from "../redux/actions/getCollections";
import { getCriteriasSymbols } from "../redux/actions/getCriterias";
import { theme } from "../constants/theme";
// import { setError } from "../redux/actions/error";

export const CollectionDetails = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  let { id }: { id: string } = useParams();
  const [criteriaModalOpen, setCriteriaModalOpen] = useState(false);

  const [categories, setCategories] = useState<Array<any>>([]);
  const [brand, setBrands] = useState<Array<any>>([]);
  const [merchant, setMerchant] = useState<Array<any>>([]);
  const [products, setProducts] = useState<Array<any>>([]);
  const [activeCriteria, setActiveCriteria] = useState<string | null>();
  const [name, setName] = useState("");
  const [criteriaData, setCriteriaData] = useState<Array<any>>([]);

  const [productList, setProductList] = useState<Array<any>>([]);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [currentCriterias, setCurrentCriterias] = useState<Array<any>>([]);

  useEffect(() => {
    dispatch(getCollectionDetailsSymbols(id));
    dispatch(getCategoriesSymbols());
    dispatch(getCriteriasSymbols());
    setProducts([]);
    setProductList([]);
    getCriterias();
  }, []); // eslint-disable-line
  const data = useSelector(
    (state: any) => state.CollectionDetailsSymbolsReducer.data
  );

  const categoryData = useSelector(
    (state: any) => state.CategorySymbolsReducer.data
  );

  const merchantData = useSelector(
    (state: any) => state.CriteriaSymbolsReducer.data?.Merchants
  );
  const brandData = useSelector(
    (state: any) => state.CriteriaSymbolsReducer.data?.Brands
  );

  const getCriterias = () => {
    axios
      .get(`/upc/collection/${id}/criteria`)
      .then((response: AxiosResponse) => {
        setCurrentCriterias(response.data.Result);
      });
  };

  const handleSubmit = () => {
    dispatch(handleSubmitBasicInfo());
    setEditModalOpen(false);
  };

  const handleSubmitBasicInfo = () => {
    const body = {
      Name: name,
    };

    return (dispatch: any) => {
      HttpRegularPut("/upc/collection/" + id, body, {
        dispatch,
        actionSuccess: () => getCollectionDetailsSymbols(id),
        // actionFailure: () => setError("Could not update!"),
        callback: () => setEditModalOpen(false),
      });
    };
  };

  const disabledLogic = (criteriaType: string) => {
    // If category selected and criteriatype === product

    if (categories && categories.length > 0 && criteriaType === "Product")
      return true;
    const nameList = currentCriterias.map((i: any) => i.Name);
    if (nameList.includes(criteriaType)) return true;
    // If product selected and criteriatype === brand or category
    // else if (
    //   products &&
    //   products.length > 0 &&
    //   (criteriaType === "Brand" || criteriaType === "Category")
    // )
    //   return true;
    else return false;
  };

  const handleSearch = (event: any) => {
    setSearchTerm(event.target.value);
  };

  const handleAddCriteria = () => {
    dispatch((disp: any) => {
      let temp: any;
      if (activeCriteria === "Category") {
        temp = [...categories];
      } else if (activeCriteria === "Brand") {
        temp = [...brand];
      } else if (activeCriteria === "Merchant") {
        temp = [...merchant];
      } else {
      }
      HttpRegularPost(
        `/upc/collection/${id}/criteria`,
        {
          Type: activeCriteria,
          Criterias: temp,
        },
        {
          dispatch: disp,
          actionSuccess: () => getCollectionDetailsSymbols(id),
          callback: () => {
            setCriteriaModalOpen(false);
            setCategories([]);
            setBrands([]);
            setMerchant([]);
            getCriterias();
            setActiveCriteria(null);
          },
        }
      );
    });
  };

  const handleDelete = () => {
    dispatch((disp: any) =>
      HttpRegularDelete(`/upc/collection/${id}`, {
        dispatch: disp,
        actionSuccess: getCollectionsSymbols,
        callback: () => history.push("/admin/collections"),
      })
    );
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />

      <Container className={classes.root}>
        <HeaderWithButtons
          handleBack={() => history.goBack()}
          title={data?.Name ?? ""}
          smallText={t('collectionDetails.promotionalBanner')}
        >
          <HeaderWithButtons.ButtonArea>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDelete}
              style={{ paddingLeft: props.loading ? "12px" : "16px" }}
            >
              {t('collectionDetails.remove')}
            </Button>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        {/** alse || shopDetailsLoading || data.length === 0 ? */}

        <>
          <Container className={classes.detailsContainer}>
            <InfoBox title={t('collectionDetails.basicInformation')}>
              <InfoLine
                name={t('collectionDetails.collectionName')}
                isLastRow
                value={data?.Name ? data.Name : t('collectionDetails.pleaseSet')}
                onClick={() => {
                  setName(data?.Name ?? "");
                  setModalTitle(t('collectionDetails.categoryName'));
                  setEditModalOpen(true);
                }}
              >
                <InfoLine.ArrowArea></InfoLine.ArrowArea>
              </InfoLine>
            </InfoBox>

            <InfoBox title={t('collectionDetails.collectionCriteria')}>
              <div className={classes.uMb8}>
                <Typography
                  display="block"
                  variant="body2"
                  component="p"
                  color="textSecondary"
                >
                  {t('collectionDetails.collectionCriteriaDescription')}
                </Typography>
              </div>
              <InfoLine
                name=""
                isLastRow
                value=""
                onClick={() => {
                  setCriteriaModalOpen(true);
                }}
              >
                <InfoLine.ArrowArea noTick>
                  <Button
                    id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                  >
                    {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
                    <Typography
                      variant="button"
                      component="span"
                      color="primary"
                      className={classes.printButtonText}
                    >
                      {t('collectionDetails.addCriteria')}
                    </Typography>
                  </Button>
                </InfoLine.ArrowArea>
              </InfoLine>

              {currentCriterias &&
                currentCriterias?.length > 0 &&
                currentCriterias.map((c: any, index: number) => (
                  <InfoLine
                    name={`CRITERIA ${index + 1}`}
                    isLastRow
                    value={c?.Criterias ?? ""}
                    smallText={c?.Name ?? ""}
                    onClick={() => {}}
                  >
                    <InfoLine.ArrowArea>
                      {/* <Button
                    id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                  >
                    <Typography
                      variant="button"
                      component="span"
                      color="primary"
                      className={classes.printButtonText}
                    >
                      {t('collectionDetails.addCriteria')}
                    </Typography>
                  </Button> */}
                    </InfoLine.ArrowArea>
                  </InfoLine>
                ))}
            </InfoBox>

            <GeneralModal
              visible={editModalOpen}
              title={modalTitle}
              description=""
              onClose={setEditModalOpen}
            >
              <GeneralModal.ContentArea>
                <TextField
                  placeholder="Merchant Name"
                  value={name}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="Name"
                  label="Name"
                  name="Name"
                  onChange={(e) => setName(e.target.value)}
                  autoFocus
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                />
              </GeneralModal.ContentArea>
              <GeneralModal.ButtonArea>
                <Button
                  onClick={() => setEditModalOpen(false)}
                  className={classes.cancelButton}
                >
                  <Typography variant="button" component="p" color="primary">
                    Cancel
                  </Typography>
                </Button>
                <Button onClick={handleSubmit} className={classes.submitButton}>
                  <Typography variant="button" component="p" color="inherit">
                    Submit
                  </Typography>
                </Button>
              </GeneralModal.ButtonArea>
            </GeneralModal>

            <GeneralModal
              visible={criteriaModalOpen}
              title={t('collectionDetails.addCriteria')}
              description=""
              onClose={setCriteriaModalOpen}
            >
              <GeneralModal.ContentArea>
                {/* CHANGE: There will be selects here */}
                <FormControl variant="outlined" className={classes.selectArea}>
                  <InputLabel id="demo-simple-select-outlined-label">
                    Collection
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={activeCriteria}
                    disabled={props?.Vertical ? true : false}
                    onChange={(event: any) => {
                      setActiveCriteria(event.target.value);
                      const cType = event.target.value;

                      if (cType === "Brand") {
                        setCriteriaData(brandData);
                      } else if (cType === "Merchant") {
                        setCriteriaData(merchantData);
                      } else if (cType === "Category") {
                        setCriteriaData(categoryData);
                      } else {
                        setCriteriaData(productList);
                      }
                    }}
                    label="Collection"
                  >
                    {/* CollectionList  */}
                    {["Brand", "Category", "Merchant"].map(
                      (v: any, index: number) => (
                        <MenuItem
                          disabled={disabledLogic(v)}
                          key={index}
                          value={v}
                        >
                          {v}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
                <Container className={classes.tabContainer}>
                  {activeCriteria !== "Product" ? (
                    (criteriaData && criteriaData.length > 0
                      ? criteriaData
                      : []
                    ).map((item: any, index: number) => (
                      <FilterGroupContainer
                        key={index}
                        letter={item?.[0] ?? ""}
                        count={item?.[1].length}
                      >
                        {item?.[1] &&
                          item?.[1].length !== 0 &&
                          item[1].map((itm: any, ind: number) => {
                            return (
                              <FilterItems
                                key={ind}
                                checked={
                                  activeCriteria === "Category"
                                    ? categories?.includes(itm.Id.toLowerCase())
                                    : activeCriteria === "Brand"
                                    ? brand.includes(itm.Id.toLowerCase())
                                    : activeCriteria === "Merchant"
                                    ? merchant?.includes(itm.Id.toLowerCase())
                                    : products?.includes(itm.Id.toLowerCase())
                                }
                                onChange={(checked: boolean) => {
                                  if (activeCriteria === "Category") {
                                    let temp = [...categories];
                                    if (checked)
                                      !temp.includes(itm.Id.toLowerCase()) &&
                                        temp.push(itm.Id.toLowerCase());
                                    else if (
                                      temp.includes(itm.Id.toLowerCase())
                                    )
                                      temp = temp.filter(
                                        (i: any) =>
                                          i.toLowerCase() !==
                                          itm.Id.toLowerCase()
                                      );
                                    setCategories(temp);
                                  } else if (activeCriteria === "Brand") {
                                    let temp = [...brand];
                                    if (checked)
                                      !temp.includes(itm.Id.toLowerCase()) &&
                                        temp.push(itm.Id.toLowerCase());
                                    else if (
                                      temp.includes(itm.Id.toLowerCase())
                                    )
                                      temp = temp.filter(
                                        (i: any) =>
                                          i.toLowerCase() !==
                                          itm.Id.toLowerCase()
                                      );

                                    setBrands(temp);
                                  } else if (activeCriteria === "Merchant") {
                                    let temp = [...merchant];
                                    if (checked)
                                      !temp.includes(itm.Id.toLowerCase()) &&
                                        temp.push(itm.Id.toLowerCase());
                                    else if (temp.includes(itm.Id))
                                      temp = temp.filter(
                                        (i: any) =>
                                          i.toLowerCase() !==
                                          itm.Id.toLowerCase()
                                      );
                                    setMerchant(temp);
                                  } else {
                                  }
                                }}
                                title={itm.Name}
                              />
                            );
                          })}
                      </FilterGroupContainer>
                    ))
                  ) : (
                    <>
                      <TextField
                        style={{ width: "100%" }}
                        variant="outlined"
                        name="Search"
                        placeholder="Search Vertical"
                        label="Search"
                        value={searchTerm}
                        onChange={handleSearch}
                      ></TextField>
                    </>
                  )}
                </Container>
              </GeneralModal.ContentArea>
              <GeneralModal.ButtonArea>
                <Button
                  onClick={() => {
                    setCriteriaModalOpen(false);
                    setCriteriaData([]);
                    setActiveCriteria(null);
                  }}
                  className={classes.cancelButton}
                >
                  <Typography variant="button" component="p" color="primary">
                    Cancel
                  </Typography>
                </Button>
                <Button
                  onClick={() => {
                    handleAddCriteria();
                  }}
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                >
                  <Typography variant="button" component="p" color="inherit">
                    Add
                  </Typography>
                </Button>
              </GeneralModal.ButtonArea>
            </GeneralModal>
          </Container>
        </>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.light,
    marginRight: "8px",
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  uMb8: {
    marginBottom: 8,
  },
  selectArea: { width: "100%", marginBottom: 15 },
  tabContainer: {
    width: "100%",
    height: 376,
    maxWidth: 320,
    paddingLeft: 4,
    paddingRight: 4,
    "overflow-y": "auto",
  },
});
